function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, propertyFilter) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['menu-content'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!propertyFilter.hasSelectedProperty()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-properties-menu", {
            "attrs": {
              'all-data-groups': $attr(`all-data-groups`),
              'data-group-id': $attr(`data-group-id`),
              'event-names': $helpers.getEventNames(),
              'exclude-dimension-properties': $attr(`exclude-dimension-properties`),
              'open': true,
              'project-has-events': $attr(`project-has-events`),
              'project-has-people': $attr(`project-has-people`),
              'project-id': $attr(`project-id`),
              'search-filter': $attr(`property-search-filter`),
              'show-all-tab': true,
              'show-items-caret': true,
              'workspace-id': $attr(`workspace-id`),
            },
            "on": {
              select: $helpers.onPropertySelect
            },
            "props": $helpers.filterAttributes({
              keydownProxyEl: $helpers.getKeydownProxyEl(),
              tooltipPositionParentElement: $helpers.getTooltipPositionParentElement(),
            }),
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-property-values-screen", {
            "attrs": $helpers.filterAttributes({
              'display-context': $attr(`display-context`),
              'event-names': $helpers.getEventNames(),
              'property-filter': JSON.stringify(propertyFilter.getAttributes()),
              'has-back-button': true,
              'project-id': $attr(`project-id`),
              'workspace-id': $attr(`workspace-id`),
            }),
            "on": {
              clickBack: $helpers.clickBackFromPropertyValues,
              changePropertyFilter: $helpers.changePropertyFilter,
              commitPropertyFilter: $helpers.commitPropertyFilter,
              draw: $helpers.dispatchDraw,
            },
            "props": $helpers.filterAttributes({
              keydownProxyEl: $helpers.getKeydownProxyEl()
            }),
          }));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-property-filter-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`has-drop-menu`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
            "attrs": {
              open: $attr(`open`),
              'prevent-close-selectors': $attr(`prevent-close-selectors`),
            },
            "on": {
              change: $helpers.changeDropMenu
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($attr(`open`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['menu-content'].call(this));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['menu-content'].call(this));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "propertyFilter" in locals ? locals.propertyFilter : typeof propertyFilter !== "undefined" ? propertyFilter : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;